/*
 * @Description:
 * @Date: 2020-11-18 15:54:18
 * @LastEditors: jml
 * @LastEditTime: 2020-11-30 18:07:28
 */
import china from '@/assets/json/china.json';
const geoCoordMap = (function() {
  var mapFeatures = china.features;
  const obj = {};
  mapFeatures.forEach(function(v) {
    // 地区名称
    var name = v.properties.name;
    // 地区经纬度
    obj[name] = v.properties.cp;
  });
  return obj;
})();
export const convertData = data => {
  return data.reduce((pre, cur) => {
    var geoCoord = geoCoordMap[cur.name.replace(/省|市/g, '')];
    if (geoCoord) {
      pre.push({
        name: cur.name,
        value: geoCoord.concat(cur.value)
      });
    }
    return pre;
  }, []);
};
